import $ from 'jquery'

function TridentShooter (node) {
  this.$node = null
  this.init(node)
}
TridentShooter.isNeeded = function () {
  return this.isTrident()
}
TridentShooter.isTrident = function () {
  const ua = navigator.userAgent
  return ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') !== -1
}
TridentShooter.shoot = function () {
  const results = []
  $('label img').each($.proxy(function (index, node) {
    results.push(new this(node))
  }, this))
  return results
}
TridentShooter.prototype.init = function (node) {
  if (this.isNeeded()) {
    this.initNode(node)
    this.initEvents()
  }
}
TridentShooter.prototype.initNode = function (node) {
  this.$node = $(node)
  this.$node.closest('label').addClass('trident-shooter')
  this.$node.data('TridentShooter', this)
}
TridentShooter.prototype.initEvents = function () {
  this.$node
    .on('click.trident', $.proxy(this.onClick, this))
}
TridentShooter.prototype.isNeeded = function () {
  return TridentShooter.isNeeded()
}
TridentShooter.prototype.onClick = function (e) {
  e.preventDefault()
  e.stopPropagation()
  this.$node.closest('label').get(0).click()
}

/**
 * イベントのクリア、nodeの参照をクリア
 */
TridentShooter.prototype.destroy = function () {
  this.$node.off('click.trident')
  this.$node = null
}
export default TridentShooter
